// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".substanceTableCss .lanauageFlag {\n  margin: 0 -1.2em 0 -0.1em !important;\n}\n.substanceTableCss .q-tab__label {\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n.substanceTableCss .q-tab {\n  height: 36px;\n}\n.lawchemChip {\n  margin-right: 5px !important;\n  cursor: pointer;\n}\n.lawchemChiptd {\n  line-height: 28px !important;\n}\n.chemavatar {\n  width: 22px !important;\n  height: 22px !important;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
